import { useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { getAccessesPages, isAdmin } from "../../services/role.service"
import { buildMenuItems, MenuItemModel } from "./buildMenuItems"
import { filterByAccess } from "./filterByAccess"
import { findActiveNavItem } from "./findActiveNavItem"
import { NAVIGATION } from "./navigation.config"
import { NavNode } from "./navigation.types"

export interface NavigationViewModel {
  items: MenuItemModel[]
  selectedKeys: string[]
  openKeys: string[]
}

export interface UseNavigationOptions {
  nodes?: NavNode[]
}

export function useNavigation(options: UseNavigationOptions = {}): NavigationViewModel {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const source = options.nodes ?? NAVIGATION

  const accessibleNodes = useMemo(
    () =>
      filterByAccess(source, {
        isAdmin: isAdmin(),
        accessibleLabels: getAccessesPages(),
      }),
    [source]
  )

  const items = useMemo(
    () => buildMenuItems(accessibleNodes, { onSelect: navigate }),
    [accessibleNodes, navigate]
  )

  const { selectedId, parentId } = useMemo(
    () => findActiveNavItem(accessibleNodes, pathname),
    [accessibleNodes, pathname]
  )

  return {
    items,
    selectedKeys: selectedId ? [selectedId] : [],
    openKeys: parentId ? [parentId] : [],
  }
}
